var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYubiLogoLargeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 34,
    viewBox: "0 0 102 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4207 27.7C12.9634 25.7545 14.7434 24.3318 16.861 24.3318C18.9785 24.3318 20.7586 25.7545 21.3012 27.7V18.7004L31.3067 8.68175C30.6582 9.03247 29.9104 9.23099 29.123 9.23099C26.5753 9.23099 24.5107 7.16637 24.5107 4.61869C24.5107 3.7849 24.7356 2.99743 25.1261 2.32246L16.861 10.5743L8.62899 2.34232C9.00618 3.01067 9.22455 3.7849 9.22455 4.61207C9.22455 7.15975 7.15994 9.22437 4.61225 9.22437C3.80493 9.22437 3.04394 9.01923 2.3822 8.64866L12.4207 18.6938V27.7Z",
    fill: "#1E2737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6123 9.2246C7.1596 9.2246 9.2246 7.1596 9.2246 4.6123C9.2246 2.065 7.1596 0 4.6123 0C2.065 0 0 2.065 0 4.6123C0 7.1596 2.065 9.2246 4.6123 9.2246Z",
    fill: "#B3BCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1296 9.2246C31.6769 9.2246 33.7419 7.1596 33.7419 4.6123C33.7419 2.065 31.6769 0 29.1296 0C26.5823 0 24.5173 2.065 24.5173 4.6123C24.5173 7.1596 26.5823 9.2246 29.1296 9.2246Z",
    fill: "#DCDC5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8611 33.5565C19.4084 33.5565 21.4734 31.4915 21.4734 28.9442C21.4734 26.3969 19.4084 24.3319 16.8611 24.3319C14.3138 24.3319 12.2488 26.3969 12.2488 28.9442C12.2488 31.4915 14.3138 33.5565 16.8611 33.5565Z",
    fill: "#EC6048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5441 29.5597C68.4433 29.5597 70.5807 28.6995 71.5866 26.9459L71.613 29.1098H75.2923V12.4406H71.4939V21.5197C71.4939 24.7225 69.5087 25.9731 67.3978 25.9731C64.903 25.9731 63.6921 24.107 63.6921 21.3741V12.4406H59.8937V21.9365C59.9003 26.6547 62.3289 29.5597 66.5441 29.5597ZM41.0872 4.66523L50.1397 18.0455V29.1164H54.1167V18.0786L63.4869 4.66523H59.1592L52.4492 14.6641L45.6598 4.66523H41.0872ZM78.0848 29.1164H81.7905L81.817 26.9525C83.0015 28.6135 85.1389 29.5333 87.4219 29.5333C91.8754 29.5333 95.7002 26.0592 95.7002 20.8116C95.7002 15.4979 91.9945 11.9973 87.4219 11.9973C85.2845 11.9973 83.1206 12.9436 81.8766 14.5516V4.66523H78.0848V29.1164ZM81.9427 20.719C81.9427 17.5161 84.5235 15.5839 86.9852 15.5839C89.7446 15.5839 91.882 17.7213 91.882 20.719C91.882 23.7166 89.7446 25.94 86.9852 25.94C84.2588 25.94 81.9427 23.9218 81.9427 20.719ZM96.898 6.68353C96.898 8.10626 98.0229 9.2643 99.4523 9.2643C100.875 9.2643 102.007 8.10626 102.007 6.68353C102.007 5.2608 100.849 4.12923 99.4523 4.12923C98.056 4.13584 96.898 5.2608 96.898 6.68353ZM97.52 29.1164H101.318V12.4406H97.52V29.1164Z",
    fill: "#1E2737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 33.5566,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYubiLogoLargeColor);
export default __webpack_public_path__ + "static/media/yubi-logo-large-color.2aff29cf64b793b6db7be2f07ac8fa31.svg";
export { ForwardRef as ReactComponent };